let workerInstance = null;
let idleTimeout = null;

const cleanUpWorker = async () => {
  if (workerInstance) {
    await workerInstance.terminate();
    workerInstance = null;
    console.log('[CivilIntelligence] OCR Worker terminated to free memory.');
  }
};

export const optimizeImage = (fileOrDataUrl) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const MAX_DIMENSION = 1500;
      let width = img.width;
      let height = img.height;
      if (width > height && width > MAX_DIMENSION) {
        height *= MAX_DIMENSION / width;
        width = MAX_DIMENSION;
      } else if (height > MAX_DIMENSION) {
        width *= MAX_DIMENSION / height;
        height = MAX_DIMENSION;
      }
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', 0.8));
    };
    img.onerror = reject;
    
    if (typeof fileOrDataUrl === 'string') {
      img.src = fileOrDataUrl;
    } else {
      const reader = new FileReader();
      reader.onload = (e) => img.src = e.target.result;
      reader.readAsDataURL(fileOrDataUrl);
    }
  });
};

export const getWorker = async (onProgress) => {
  if (idleTimeout) clearTimeout(idleTimeout);

  if (!workerInstance) {
    onProgress(10, 'بارگذاری موتور بینایی ماشین...');
    if (!window.Tesseract) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js';
        script.onload = resolve;
        script.onerror = () => reject(new Error('خطا در بارگذاری موتور OCR'));
        document.head.appendChild(script);
      });
    }

    onProgress(20, 'پیکربندی هسته هوش مصنوعی (فارسی و انگلیسی)...');
    try {
      workerInstance = await window.Tesseract.createWorker('eng+fas', 1, {
        workerPath: 'https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/worker.min.js',
        langPath: 'https://tessdata.projectnaptha.com/4.0.0',
        corePath: 'https://cdn.jsdelivr.net/npm/tesseract.js-core@5.0.0',
        logger: m => {
          if (m.status === 'recognizing text') {
            onProgress(40 + Math.floor(m.progress * 50), 'تحلیل پیکسلی سند مهندسی...');
          }
        }
      });
    } catch (err) {
      workerInstance = null;
      throw new Error('خطا در دانلود بسته زبانی.');
    }
  }

  idleTimeout = setTimeout(cleanUpWorker, 5 * 60 * 1000);
  return workerInstance;
};

export const processOCR = async (file, onProgress) => {
  const optimizedDataUrl = await optimizeImage(file);
  const worker = await getWorker(onProgress);
  onProgress(35, 'بهینه‌سازی رزولوشن...');
  const { data: { text } } = await worker.recognize(optimizedDataUrl);
  onProgress(100, 'استخراج داده‌ها با موفقیت پایان یافت.');
  return text || 'متنی در این تصویر یافت نشد.';
};
